import React, {useState} from 'react';

import {PopoverBody} from 'reactstrap';
import styled from 'styled-components';

import {PopoverForm} from 'app/general/overlays';
import StateButton from 'app/general/widgets/StateButton';
import {gt} from 'app/utils/i18n';

import type {OverlayProps} from 'app/general/overlays';
type Props = {
  addVideo: (url: string) => Promise<any>;
  overlayProps: OverlayProps;
};
const StyledVideoInputContainerDiv = styled.div`
  width: 250px;
`;
export function EmbedVideoPopover({addVideo, overlayProps}: Props) {
  const [videoURL, setVideoURL] = useState<string>('');
  return (
    <PopoverForm overlayProps={overlayProps}>
      {({closeOnSuccess}) => (
        <PopoverBody>
          <StyledVideoInputContainerDiv className="input-group input-group-sm">
            <input
              className="form-control"
              onChange={(e) => setVideoURL(e.target.value)}
              value={videoURL}
              placeholder={gt('Video URL or embed code')}
            />
            <span className="input-group-append">
              <StateButton
                className="btn btn-secondary"
                busyText={gt('Adding')}
                disabled={!videoURL}
                onClick={() => closeOnSuccess(addVideo(videoURL))}
              >
                {gt('Add')}
              </StateButton>
            </span>
          </StyledVideoInputContainerDiv>
        </PopoverBody>
      )}
    </PopoverForm>
  );
}
